<!--
 * @Author: cryi.liu
 * @Date: 2020-05-15 14:01:41
 * @LastEditTime: 2020-06-20 11:20:18
 * @Description: 本场考考试信息
 -->
<template>
  <div class="current-exam-info">
    <p class="type">{{ currentQuestionType }}题</p>
    <p class="survey">
      第
      <span>{{ currentQuestionIndex + 1 }}</span>
      题/共
      <span>{{ libraryInfo.length }}</span>
      题
    </p>
    <p class="time">
      <i-icon type="md-time" size="16" />
      距离考试结束还有：
      <span>{{ timeRemaining }}</span>
      分钟
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'CurrentExamInfo',
  props: {
    currentQuestionIndex: { type: Number, required: true },
    currentQuestionType: { type: String, required: true },
    timeRemaining: { type: String, required: true },
  },
  computed: {
    ...mapGetters({
      libraryInfo: 'onlineExamStore/libraryInfo',
    }),
  },
};
</script>

<style lang="less" scoped>
.current-exam-info {
  width: 100%;
  font-size: 14px;
  display: flex;
  justify-content: space-between;

  > .survey {
    > span {
      color: red;
    }
  }

  > .time {
    > span {
      color: red;
    }
  }
}
</style>
